export async function checkEmpresa({ store, to }) {
  const prefix = '[CheckEmpresa Middleware]';

  // 1. Log de entrada
  console.log(`%c${prefix} Iniciando verificación para la ruta: ${to.name}`, 'color: #2196F3; font-weight: bold;');
  console.log("store state empresa: ",store.state.empresa.empresa);
  
  // 2. Si el estado es null o inicial, forzamos la petición al servidor primero
  if (store.state.empresa.empresa === null) {
    console.log(`%c${prefix} Estado en Store es NULL. Consultando API...`, 'color: #9E9E9E; font-style: italic;');
    try {
      await store.dispatch('empresa/fetchEmpresaPublic', );
      console.log(`%c${prefix} API respondida. Nuevo estado: ${store.state.empresa.empresa}`, 'color: #4CAF50;');
    } catch (error) {
      console.error(`${prefix} Error crítico consultando empresa:`, error);
    }
  }

  const empresa = store.state.empresa.empresa;

  // CASO A: No hay empresa (Subdominio inválido o empresa inexistente)
  if (!empresa) {
    console.warn(`${prefix} Resultado: La empresa NO existe.`);
    
    if (to.name !== 'landing') {
      console.log(`%c${prefix} ACCESO DENEGADO: Redirigiendo a Landing (Cascarón)`, 'color: #FF5252; font-weight: bold;');
      return { name: 'landing' };
    }
    
    console.log(`${prefix} Ya estás en Landing. No hay empresa, pero se permite ver el cascarón.`);
    return null;
  }

  // CASO B: SI hay empresa.
  if (empresa) {
    console.log(`%c${prefix} ÉXITO: Empresa detectada. Cediendo control al Router/Auth.`, 'color: #4CAF50; font-weight: bold;');
    
    // Debug preventivo: si por error intentas entrar a landing teniendo empresa, 
    // podrías querer ver este log para saber por qué no te saca de ahí.
    if (to.name === 'landing') {
      console.log(`%c${prefix} Info: Estás en la Landing, pero la empresa existe. Podrías loguearte.`, 'color: #FF9800;');
    }
    
    return null;
  }

  // Fallback de seguridad (nunca debería llegar aquí)
  console.error(`${prefix} Error lógico: Se llegó al final de la función sin resolver.`);
  return null;
}